const hideZeroReviewsInterval = setInterval(() => {


  const bvStars = document.querySelectorAll('.klevuProduct');


  if (bvStars.length > 0) {
    let allLoaded = true;

    
    bvStars.forEach(el => {
      // If the review container is still empty, skip for now
      if (!el.textContent.trim()) {
        allLoaded = false;
         
      }
    });

    if (allLoaded) {
      //clearInterval(hideZeroReviewsInterval);

      $('.kuResults .klevuProduct').each((index, product) => {
          const product_review = $(product).find('.star-rating-klevu');
          const review_text = product_review.find('.bv_averageRating_component_container .bv_text').text().trim();
                        
          if (review_text === "0.0" || review_text === "0") {
            
            product_review.hide();
          }
        });
      
    }
  }
}, 300);


const hideCollecTagOnPharmacyProducts = setInterval(() => {


  const bvStars = document.querySelectorAll('.klevuProduct');


  if (bvStars.length > 0) {
    let allLoaded = true;

    
    bvStars.forEach(el => {
      // If the review container is still empty, skip for now
      if (!el.textContent.trim()) {
        allLoaded = false;
         
      }
    });

    if (allLoaded) {
      //clearInterval(hideCollecTagOnPharmacyProducts);

      $('.kuResults .klevuProduct').each((index, product) => {
          const product_Div_calss = $(product).find('.collection-product-item');
          const dataID = product_Div_calss.attr('data-id');
          const clickCollectlabel = $(product).find('span.product-label.product-label--custom1.product-label--northwood');
        
          if (product_Div_calss.hasClass('isPharmacistOnlyTag')) {
            
          }else{
            clickCollectlabel.show();
          }
        });

    }
  }
}, 300);

const hideReviewsProductInterval = setInterval(() => {
 
  const bvStars = $('.product-block-list__item--info');

  if (bvStars.length > 0) {
    let allLoaded = true;

    bvStars.each(function () {
      if (!$(this).text().trim()) {
        allLoaded = false;
        return false; // break the loop early
      }
    });

    if (allLoaded) {
      const productReview = $('.bv_main_container');
      const reviewText = productReview.find('.bv_numReviews_text').text().trim();

      const ratingSummaryDiv = document.querySelector('div[data-bv-show="rating_summary"]');
            
      console.log(reviewText);
      
      if ( reviewText === "0" || reviewText === "" ) {
      }
        else if(reviewText == "(0)"){
          bvStars.addClass('stoploop');
        console.log('class added');
        }
      else{
        ratingSummaryDiv.style.setProperty('display', 'block');
        bvStars.addClass('stoploop');
        console.log('class added');
      }

      if(bvStars.hasClass('stoploop')){
        clearInterval(hideReviewsProductInterval); // ✅ clear the interval after done
        console.log('Checking reviews stopped');
      }
      
    }
  }
}, 300);

// const hideReviewsProductInterval = setInterval(() => {


//   const bvStars = document.querySelectorAll('.product-block-list__item--info');


//   if (bvStars.length > 0) {
//     let allLoaded = true;


//     bvStars.forEach(el => {
//       // If the review container is still empty, skip for now
//       if (!el.textContent.trim()) {
//         allLoaded = false;

//       }
//     });

//     if (allLoaded) {
//       //clearInterval(hideCollecTagOnPharmacyProducts);


//           const product_review = $(product).find('.bv_main_container');
//           const review_text = product_review.find('.bv_numReviews_text').text().trim();

//           if (review_text === "0.0" || review_text === "0") {

//             product_review.hide();

//           }


//     }
//   }
// }, 300);

// StoreLocator js

document.querySelector('.location-input').addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
        event.preventDefault(); // Prevent the default form submission
        const searchButton = document.querySelector('.find-store');
        if (searchButton) {
            searchButton.click(); // Trigger the click event on the search button
        }
    }
});